"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const all_1 = require("../all");
const utils_1 = require("@obvio/utils");
exports.default = (0, all_1.createTheme)({
    font: 'Sora, sans-serif',
    secondaryFont: 'Ogg, serif',
    footerHeight: '31rem',
    mobileFooterHeight: 'calc(100vh - var(--nav-height))',
    colors: {
        primary: (0, utils_1.createColor)('#F5F2EE'),
        secondary: (0, utils_1.createColor)('#31352C'),
        complementary: (0, utils_1.createColor)('#8C8A7C', {
            semidark: '#5a5c53',
            semilight: '#A4A297',
        }),
        gray: (0, utils_1.createColor)('#A4A6A5'),
        additional: ['#BCBBB3'],
    },
    stroke: '#BCBBB3',
    page: {
        width: '67rem',
    },
    global: (0, all_1.css) `
    html {
      font-size: 14px;
    }
    :root {
      --nav-height: 6.875rem;
      -webkit-font-smoothing: antialiased;
      text-rendering: optimizeLegibility;
      -moz-osx-font-smoothing: grayscale;
    }
  `,
    buttons: {
        css: (0, all_1.css) `
      height: 2.25rem;
    `,
        ghost: (0, all_1.css) `
      background: transparent;
      border: 1px solid ${(theme) => theme.stroke};
    `,
        transparent: (0, all_1.css) `
      background: transparent;
      color: ${(theme) => theme.colors.gray};
      &:hover {
        background: transparent !important;
        text-decoration: none !important;
      }
    `,
    },
    background: '#F5F2EE',
    typography: {
        css: (0, all_1.css) `
      word-break: break-word;
    `,
        h1: (0, all_1.css) `
      font-size: 2rem;
      font-family: ${(theme) => theme.secondaryFont};
      font-weight: 400;
    `,
        h2: (0, all_1.css) `
      font-size: 1rem;
      line-height: 125%;
      font-weight: 500;
      letter-spacing: 3px;
      display: initial;
    `,
        h3: (0, all_1.css) `
      font-size: 1.25rem;
      font-weight: 300;
      line-height: 135%;
      font-family: ${(theme) => theme.font};

      b {
        font-family: ${(theme) => theme.font};
      }

      @media ${all_1.mobile} {
        font-size: 2rem;
      }
    `,
        p: (0, all_1.css) `
      font-size: 1rem;
      font-weight: 300;
      line-height: 170%;
      font-family: ${(theme) => theme.font};
    `,
    },
    context: {
        'mini-bar': {
            page: {
                width: '46rem',
                sectionSpacing: {
                    desktop: '3rem',
                    notDesktop: '3rem',
                },
            },
            buttons: {
                css: (0, all_1.css) `
          padding: 0;
          min-height: unset;
          min-width: unset;
          background: #5a5c53;
          border-radius: 0;
        `,
            },
            inputs: {
                css: (0, all_1.css) `
          height: auto;
          min-width: 0;
          max-width: 6rem;
          border-bottom: none;
          color: ${(theme) => theme.colors.secondary};
        `,
                select: {
                    css: (0, all_1.css) `
            border-bottom: 0;
          `,
                    label: (0, all_1.css) `
            position: static;
            background: transparent;
            color: ${(theme) => theme.colors.secondary};
            font-weight: 300;
            font-size: 1rem;
            &.focus-visible,
            &.with-value {
              font-size: 1rem;
            }
          `,
                },
                checkbox: {
                    css: (0, all_1.css) `
            border-radius: 9999px !important;
            min-height: 1.1875rem;
            min-width: 1.1875rem;
            border-width: 1px;
            --border: #5a5c53;
            &:checked {
              --bg: #5a5c53;
              --border: #5a5c53;
              --active-inner: transparent;
            }
          `,
                },
            },
        },
        order: {
            inputs: {
                css: (0, all_1.css) `
          height: 3.5rem;
          padding: 0 1rem;
          border: 0.0625rem solid ${(theme) => theme.stroke};
          border-radius: ${(theme) => theme.radius.small};
          ${all_1.styled.focus `
            border: 0.0625rem solid ${(theme) => theme.colors.primary};
            border-color: ${(theme) => theme.colors.primary};
            box-shadow: 0px 0px 0px 0.0625rem ${(theme) => theme.colors.primary};
          `}
        `,
                textarea: {
                    label: (0, all_1.css) `
            top: 1rem;
            bottom: unset;
          `,
                },
                label: (0, all_1.css) `
          cursor: text;
          color: ${(theme) => theme.colors.gray.semilight};
          z-index: 1;
          font-size: 1rem;
          margin-left: 0.75rem;
          user-select: none;
          position: absolute;
          top: 0.0625rem;
          bottom: 0.0625rem;
          left: ${(theme) => theme.spacing.small};
          display: flex;
          align-items: center;
          padding: 0.15rem;
          transition: 150ms all;
          font-size: 1.0625rem;
          color: ${(theme) => theme.colors.gray};
          margin: 0;
          &.focus-visible,
          &.with-value {
            top: -0.625rem;
            bottom: unset;
            left: 0.5rem;
            font-size: 0.8125rem;
            padding: 0 0.25rem;
            background-color: ${(theme) => theme.background};
          }
        `,
            },
            colors: {
                gray: (0, utils_1.createColor)('#8F95A3', {
                    intense: '#F6F7F9',
                    light: '#D2D8E2',
                    semilight: '#ABAFBA',
                    semidark: '#6E7080',
                    dark: '#4A4C55',
                    deep: '#1D1E21',
                }),
            },
            buttons: {
                css: (0, all_1.css) `
          border-radius: 0.625rem;
          height: 3.5rem;
          background: ${(theme) => theme.colors.gray};
          color: white;
          font-size: 1.0625rem;
          line-height: 150%;
        `,
            },
            typography: {
                css: (0, all_1.css) `
          color: black;
          font-family: 'DM Sans', sans-serif;
        `,
                h2: (0, all_1.css) `
          font-family: 'DM Sans', sans-serif;
          font-size: 1.375rem;
          font-weight: 500;
        `,
                h3: (0, all_1.css) `
          font-family: 'DM Sans', sans-serif;
          font-size: 0.9375rem;
          font-weight: 700;
          @media ${all_1.mobile} {
            font-weight: 700;
            line-height: 150% !important;
            letter-spacing: 0.1px;
            font-size: 0.9375rem;
            padding-bottom: ${(theme) => theme.spacing.extraSmall};
            white-space: nowrap;
          }
        `,
            },
        },
        navForm: {
            inputs: {
                label: (0, all_1.css) `
          ${all_1.styled.focus `
            color: ${(theme) => theme.colors.complementary.semidark};
          `}
        `,
                checkbox: {
                    css: (0, all_1.css) `
            --active: ${(theme) => theme.colors.complementary};
          `,
                },
            },
            typography: {
                h2: (0, all_1.css) `
          @media ${all_1.mobile} {
            font-size: 2.25rem;
          }
        `,
            },
        },
        sign: {
            typography: {
                css: (0, all_1.css) `
          color: ${(theme) => theme.colors.secondary};
        `,
            },
            links: {
                css: (0, all_1.css) `
          color: ${(theme) => theme.colors.secondary};
        `,
            },
            buttons: {
                ghost: (0, all_1.css) `
          background: transparent;
          border: 2px ${(theme) => theme.colors.secondary} solid;
          color: ${(theme) => theme.colors.secondary};
          height: 2rem;
          padding: ${(theme) => `${theme.spacing.extraSmall} ${theme.spacing.small}`};
          font-size: 0.8125rem;
          letter-spacing: 0.175rem;
          width: auto !important;
          margin: 0 auto;
          font-weight: 500;
        `,
            },
            inputs: {
                css: (0, all_1.css) `
          color: ${(theme) => theme.colors.secondary};
          height: 2.5rem;
          border-radius: 0;
          border: none;
          border-bottom: 1px solid ${(theme) => theme.colors.secondary};
          margin-top: 0.0625rem;
          ${all_1.styled.focus `
            box-shadow: none;
          `}
          ${all_1.styled.disabled `
            opacity: 0.3;
          `}
        `,
                label: (0, all_1.css) `
          cursor: text;
          color: ${(theme) => theme.colors.secondary};
          z-index: 1;
          font-size: 1rem;
          margin-left: 0.75rem;
          user-select: none;
          position: absolute;
          top: 0.0625rem;
          bottom: 0.0625rem;
          display: flex;
          align-items: center;
          padding: 0.15rem;
          transition: 150ms all;
          font-size: 1.0625rem;
          color: ${(theme) => theme.colors.primary};
          margin: 0;
          &.focus-visible,
          &.with-value {
            top: -0.625rem;
            bottom: unset;
            font-size: 0.8125rem;
            padding: 0 0.25rem;
            background-color: ${(theme) => theme.background};
          }
          ${all_1.styled.disabled `
            opacity: 0.3;
          `}
        `,
            },
        },
        ecommerce: {
            spacing: {
                extraLarge: '10rem',
                large: '6.875rem',
                big: '3.75rem',
                medium: '2.875rem',
                small: '1.875rem',
                extraSmall: '0.75rem',
            },
            colors: {
                primary: (0, utils_1.createColor)('#8C8A7C'),
                secondary: (0, utils_1.createColor)('#31352C'),
                complementary: (0, utils_1.createColor)('#DFC2C5'),
            },
            typography: {
                css: (0, all_1.css) `
          color: ${(theme) => theme.colors.primary.deep};
        `,
            },
            stroke: '#BCBBB3',
            links: {
                css: (0, all_1.css) `
          color: ${(theme) => theme.stroke};
          &:hover {
            color: #636a51;
          }
        `,
            },
            buttons: {
                css: (0, all_1.css) `
          border-radius: 0;
          padding: 0 ${(theme) => theme.spacing.small};
          text-transform: uppercase;
          color: white;
          height: 4rem;
          font-size: 0.8125rem;
          font-weight: 500;
          letter-spacing: 0.175rem;
          background: ${(theme) => theme.colors.primary};
          ${all_1.styled.disabled `
            opacity: 0.5;
          `}
          &:hover {
            filter: brightness(1.1);
          }
          transition: all 0.2s;
        `,
                icon: (0, all_1.css) `
          padding: 0;
          width: 3.5rem;
          min-width: unset;
          @media ${all_1.mobile} {
            width: 3.5rem;
          }
        `,
                transparent: (0, all_1.css) `
          background: transparent;
          color: ${(theme) => theme.colors.gray};
          &:hover {
            background: ${(theme) => theme.colors.gray.intense};
            text-decoration: none !important;
            filter: unset;
          }
          transition: all 0.2s;
        `,
            },
            inputs: {
                css: (0, all_1.css) `
          color: ${(theme) => theme.colors.secondary};
          height: 2.875rem;
          &::placeholder {
            color: ${(theme) => theme.colors.secondary};
            opacity: 0.5;
            font-weight: 500;
            line-height: 1.5rem;
          }
          border-radius: 0;
          border: 1px solid ${(theme) => theme.stroke};
          box-shadow: none;
          margin-top: 0;
          > div > input {
            outline: none;
          }
          > div[data-type='suffix'] {
            font-weight: bold;
            font-size: 0.9375rem;
          }
        `,
                label: (0, all_1.css) `
          font-size: 1rem;
          margin-left: 0.75rem;
        `,
            },
        },
        richText: {
            typography: {
                h2: (0, all_1.css) `
          font-size: 3rem;
          line-height: 135%;
          @media ${all_1.mobile} {
            font-size: 2rem;
          }
        `,
            },
        },
    },
    inputs: {
        css: (0, all_1.css) `
      color: ${(theme) => theme.colors.secondary};
      height: 2.5rem;
      &::placeholder {
        color: ${(theme) => theme.colors.secondary};
        opacity: 0.5;
        font-weight: 500;
        line-height: 1.5rem;
      }
      border-radius: 0;
      border: none;
      margin-top: 0.0625rem;
      border-bottom: 1px solid ${(theme) => theme.colors.complementary};
    `,
        textarea: {
            label: (0, all_1.css) `
        top: 1rem;
        bottom: unset;
      `,
        },
        label: (0, all_1.css) `
      cursor: text;
      color: ${(theme) => theme.colors.secondary};
      z-index: 1;
      font-size: 1rem;
      user-select: none;
      position: absolute;
      top: 125%;
      display: flex;
      align-items: center;
      padding: 0.15rem;
      transition: 150ms all;
      font-size: 1.0625rem;
      margin: 0;
    `,
    },
});
